import React, { useState, useRef, useEffect } from 'react';
import { Building2, MapPin, Phone, Mail, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../components/ui/carousel';
import CountSection from '@/components/CountSection';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const [utmSource, setUtmSource] = useState("google");
  const currentDate = new Date().toLocaleDateString("en-GB").replace(/-/g, "/");

  const initialValues = {
    name: "",
    email: "",
    mobile: "",
    date: currentDate,
    subject: "New Registration",
    leadSource: utmSource,
  };
  const [sending, setSending] = useState(false);
  const [data, setData] = useState(initialValues);
  const [formError, setFormError] = useState({});
  const [disableButton, setDisableButton] = useState(false);
  const [mailURL, setMailURL] = useState("");
  const [location, setLocation] = useState("");
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    if (location.hash === "#contact-map") {
      setTimeout(() => {
        const element = document.getElementById("contact-map");

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);
    }
  }, [location]);



  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const utm_source =
      urlParams.get("utm_source") || "google";

    setUtmSource(utm_source);

    setData((prev) => ({
      ...prev,
      leadSource: utm_source,
    }));
  }, []);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((ipData) => {
        setData((prev) => ({
          ...prev,
          ipAddress: ipData.ip,
        }));
      })
      .catch(() => {
        console.log("Failed to fetch IP");
      });
  }, []);

  const validate = (values) => {
    const errors = {};

    if (!values.name)
      errors.name = "Name is required";

    if (!values.email) {
      errors.email = "Email is required";
    } else {
      const emailRegex =
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      if (!emailRegex.test(values.email)) {
        errors.email = "Invalid Email";
      }
    }
    if (!values.mobile) {
      errors.mobile = "Phone number is required";
    } else if (!/^\d{10}$/.test(values.mobile)) {
      errors.mobile = "Enter a valid 10-digit phone number";
    }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => ({
      ...prev,
      [name]: value,
      leadSource: utmSource,
    }));
  };
  useEffect(() => {
    const endpoint = process.env.REACT_APP_ENDPOINT_MAIL_URL;
    console.log("url", process.env.REACT_APP_ENDPOINT_MAIL_URL)
    const fullURL = `${window.location.origin}${endpoint}${process.env.REACT_APP_SEND_MAIL_TOKEN
      ? `${endpoint.includes("?") ? "&" : "?"}token=${encodeURIComponent(
        process.env.REACT_APP_SEND_MAIL_TOKEN)}`
      : ""
      }`;
    console.log("token", fullURL)
    setMailURL(fullURL);
  }, []);


  const sendMail = async (e) => {
    e.preventDefault();

    if (!mailURL) return;

    const errors = validate(data);
    setFormError(errors);

    if (Object.keys(errors).length > 0) return;
    setSending(true);

    try {



      const response = await fetch(mailURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Request failed");
      }

      setSubmitted(true);

      setData({
        name: "",
        message: "",
        email: "",
        mobile: "",
        date: currentDate,
        ipAddress: "",
        subject: "Query",
        leadSource: utmSource,
        project: "",
      });

      setTimeout(() => {
        navigate("/thankyou");
      }, 1000);
    } catch (error) {
      alert("Something went wrong. Please try again.");
    }
  };
  const videoRef = useRef(null);
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Mock submission
  //   toast.success("Thank you for your interest!", {
  //     description: "Our team will contact you shortly.",
  //   });
  //   setData({ name: '', email: '', phone: '', message: '' });
  // };

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        {/* <img 
          src="https://images.pexels.com/photos/7822978/pexels-photo-7822978.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
          alt="Premium Township" 
          className="hero-image"
        /> */}
        <video ref={videoRef} className="absolute inset-0 w-full h-full object-cover will-change-transform" autoPlay muted loop playsInline style={{ transform: "scale(1)" }}>
          <source src="/videos/HomeVideo.mp4" type="video/mp4" />
        </video>
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">A Landmark Beyond Compare</h1>
            <p className="hero-subtitle">Three Legacy Builders. One Exceptional Township in New Chandigarh.</p>
            <div className="hero-partners">
              <span className="separator">•</span>
              <span>Rattha Group</span>
              <span className="separator">•</span>
              <span>Affinity Buildtech</span>
              <span className="separator">•</span>
              <span>HLP Group</span>
            </div>
          </div>
        </div>
      </section>
      <CountSection />

      {/* Rattha Group Section */}
      <section id='rattha-group' className="group-section alternate">
        <div className="container">
          <div className="group-visual-layout">
            <div className="group-info">
              <div className="group-logo-container">
                <img
                  src="/assets/Rattha_grouplogo.png"
                  alt="Rattha Group"
                  className="group-logo"
                />
              </div>
              <div className="group-header">
                <h2 className="group-title">Rattha Group</h2>
                <p className="group-tagline">Vision on Wings</p>
              </div>
              <div className="group-description">
                <p>
                  Rattha Group, established in 1992 and headquartered in Chennai, is a diversified conglomerate with a strong presence across real estate, hospitality, healthcare, clothing, and co-working sectors. Guided by the philosophy of being “greater than the sum of its parts,” the group focuses on strategic investments, operational excellence, and long-term value creation.
                </p>
                <p className="group-philosophy">
                  With operations in 15 countries, supported by 10 global partners and a workforce of 6000+ professionals, Rattha consistently delivers high-quality developments and global-standard services.
                </p>
              </div>
            </div>
            <div className="group-carousel">
              <Carousel className="project-carousel">
                <CarouselContent>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="assets/ratthatekmedows.png"
                        alt="Contemporary Apartments"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="assets/bellavesta.png"
                        alt="Modern Villa Development"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="assets/silverspring.png"
                        alt="Premium Residential Complex"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="assets/somerset.png"
                        alt="Premium Residential Complex"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                </CarouselContent>
                <CarouselPrevious />
                <CarouselNext />
              </Carousel>
            </div>
            <div className="projects-showcase">
              <h3 className="projects-title">Notable Projects</h3>
              <div className="projects-grid">
                <div className="project-card">
                  <span className="project-name">Prestige Bella Vista</span>
                  <span className="project-location">Porur, Chennai</span>
                </div>
                <div className="project-card">
                  <span className="project-name">IT SEZ Chennai</span>
                  <span className="project-location">Chennai</span>
                </div>
                <div className="project-card">
                  <span className="project-name">Residential Developments</span>
                  <span className="project-location">Multiple Locations</span>
                </div>
                <div className="project-card">
                  <span className="project-name">Business Centres</span>
                  <span className="project-location">Pan India</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Affinity Buildtech Section */}
      <section id='affinity-buildtech' className="group-section">
        <div className="container">
          <div className="group-visual-layout">
            <div className="group-info">
              <div className="group-logo-container">
                <img
                  src="/assets/Affinity_Buildtech.png"
                  alt="Affinity Buildtech"
                  className="group-logo"
                />
              </div>
              <div className="group-header">
                <h2 className="group-title">Affinity Buildtech</h2>
                <p className="group-tagline">Commitment. Honesty. Transparency.</p>
              </div>
              <div className="group-description">
                <p>
                  Affinity Buildtech envisions developing environment-friendly spaces that strike a balance between country life and city life, giving way to sustainable, green, and luxury living which is affordable by all. The mission is to provide homes that not only offer a high standard of living but also incorporate a feeling of belongingness through healthy community living.
                </p>
              </div>
            </div>
            <div className="group-carousel">
              <Carousel className="project-carousel">
                <CarouselContent>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/Belgravia.png"
                        alt="Affinity Belgravia"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/Affinity_greens.png"
                        alt="Affinity Greens"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/Eminence.png"
                        alt="The Eminence"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/Eminence_Plaza.png"
                        alt="Eminence Plaza"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  
                </CarouselContent>
                <CarouselPrevious />
                <CarouselNext />
              </Carousel>
            </div>
            <div className="projects-showcase">
              <h3 className="projects-title">Award-Winning Projects</h3>
              <div className="projects-grid">
                <div className="project-card">
                  <span className="project-name">Affinity Belgravia</span>
                  <span className="project-location">Zirakpur</span>
                </div>
                <div className="project-card">
                  <span className="project-name">Affinity Greens</span>
                  <span className="project-location">Zirakpur</span>
                </div>
                <div className="project-card">
                  <span className="project-name">The Eminence</span>
                  <span className="project-location">Zirakpur</span>
                </div>
                <div className="project-card">
                  <span className="project-name">Eminence Plaza</span>
                  <span className="project-location">Zirakpur</span>
                </div>
                <div className="project-card">
                  <span className="project-name">Venezia Floors</span>
                  <span className="project-location">Zirakpur</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HLP Group Section */}
      <section id='hlp-group'
        className="group-section alternate">
        <div className="container">
          <div className="group-visual-layout">
            <div className="group-info">
              <div className="group-logo-container">
                <img
                  src="/assets/Group_logo_hlp.png"
                  alt="HLP Group"
                  className="group-logo"
                />
              </div>
              <div className="group-header">
                <h2 className="group-title">HLP Group</h2>
                <p className="group-tagline">Building a Lifestyle, Not Just Real Estate</p>
              </div>
              <div className="group-description">
                <p>
                  Since 1997, HLP Group has been shaping landmark residential and commercial developments with a focus on quality, innovation, and timely delivery. Known for thoughtfully designed spaces, strategic locations, and modern infrastructure, HLP creates destinations that elevate lifestyles and redefine urban living.
                </p>
                <p className="group-philosophy">
                  Driven by excellence, HLP continues to set new benchmarks in real estate and infrastructure development.
                </p>
              </div>
            </div>
            <div className="group-carousel">
              <Carousel className="project-carousel">
                <CarouselContent>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/Galleria.png"
                        alt="HLP Galleria"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/Square.png"
                        alt="HLP Social Square"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/Bella_Homes.png"
                        alt="Bella Homes"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/Aero_Arcade.png"
                        alt="Aero Arcade"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                   <CarouselItem>
                    <div className="carousel-image-wrapper">
                      <img
                        src="/assets/hlp_farmfield.png"
                        alt="HLP_farm_fields"
                        className="carousel-image"
                      />
                    </div>
                  </CarouselItem>
                </CarouselContent>
                <CarouselPrevious />
                <CarouselNext />
              </Carousel>
            </div>
            <div className="projects-showcase">
              <h3 className="projects-title">Signature Developments</h3>
              <div className="projects-grid">
                <div className="project-card">
                  <span className="project-name">HLP Galleria</span>
                  <span className="project-location">Sector-62, Mohali</span>
                </div>
                <div className="project-card">
                  <span className="project-name">HLP Social Square</span>
                  <span className="project-location">Zirakpur</span>
                </div>
                <div className="project-card">
                  <span className="project-name">Bella Homes I & II</span>
                  <span className="project-location">Sector-5, Derabassi</span>
                </div>
                <div className="project-card">
                  <span className="project-name">Aero Arcade</span>
                  <span className="project-location">Aerocity, Mohali</span>
                </div>
                <div className="project-card">
                  <span className="project-name">Urban Vatika</span>
                  <span className="project-location">Zirakpur</span>
                </div>
                <div className="project-card">
                  <span className="project-name">HLP Farmfields</span>
                  <span className="project-location">New Chandigarh</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info">
              <h2 className="contact-title">Register Your Interest</h2>
              <p className="contact-description">
                Be among the first to experience this premium township. Share your details and our team will reach out to you.
              </p>
              <div className="contact-features">
                <div className="feature-item">
                  <Building2 className="feature-icon" />
                  <span>Premium Residential Plots</span>
                </div>
                <div className="feature-item">
                  <MapPin className="feature-icon" />
                  <span>Strategic Location in New Chandigarh</span>
                </div>
              </div>
            </div>
            <form className="contact-form" onSubmit={sendMail}>
              <div className="form-group">
                <Input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={data.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
                {formError.name && (
                  <p className="text-red-500 text-xs mt-1">
                    {formError.name}
                  </p>
                )}
              </div>
              <div className="form-group">
                <Input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={data.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
                {formError.email && (
                  <p className="text-red-500 text-xs mt-1">
                    {formError.email}
                  </p>
                )}
              </div>
              <div className="form-group">

                <Input
                  type="tel"
                  name="mobile"
                  placeholder="Enter phone number"
                  value={data.mobile}
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    setData((prev) => ({
                      ...prev,
                      mobile: value,
                      leadSource: utmSource,
                    }));
                  }}
                  className="form-input"
                />
                {formError.mobile && (
                  <p className="text-red-500 text-xs mt-1">
                    {formError.mobile}
                  </p>
                )}
              </div>
              <div className="form-group">

                <Textarea
                  name="message"
                  placeholder="Message (Optional)"
                  value={data.message}
                  onChange={handleChange}
                  rows={4}
                  className="form-input"
                />
                {formError.message && (
                  <p className="text-red-500 text-xs mt-1">
                    {formError.message}
                  </p>
                )}
              </div>
              <Button type="submit" className="submit-button">
                {sending ? "Submitting Inquiry..." : "Submit Inquiry"}

                <ArrowRight className="button-icon" />
              </Button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3 className="footer-brand">Premium Township</h3>
              <p className="footer-tagline">New Chandigarh</p>
              <p className="footer-text">
                A joint venture by Rattha Group, Affinity Buildtech and HLP Group.
              </p>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Contact Information</h4>
              <div className="footer-contact">
                <div className="contact-item">
                  <Phone size={16} />
                  <span>+91 98148 66776</span>
                </div>
                <div className="contact-item">
                  <Mail size={16} />
                  <span>varunsharma@countygreen.in</span>
                </div>
                <div className="contact-item">
                  <MapPin size={16} />
                  <span>New Chandigarh, Punjab, India</span>
                </div>
              </div>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Partner Groups</h4>
              <ul className="footer-links">
                <li><a href="#rattha-group">Rattha Group</a></li>
                <li><a href="#affinity-buildtech">Affinity Buildtech</a></li>
                <li><a href="#hlp-group">HLP Group</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2025 Premium Township. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
